import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasApproverGuideSuggestionSchema = withDefaults({
  type: 'tas-approver-guide-suggestion',
  fields: [
    { kind: 'attribute', name: 'guideId' },
    { kind: 'attribute', name: 'sectionKey' },
    { kind: 'attribute', name: 'proposedMarkdown' },
    { kind: 'attribute', name: 'baseMarkdown' },
    { kind: 'attribute', name: 'note' },
    { kind: 'attribute', name: 'status' },
    { kind: 'attribute', name: 'resolutionNote' },
    { kind: 'attribute', name: 'resolvedAt' },
    { kind: 'attribute', name: 'createdBy' },
    { kind: 'attribute', name: 'updatedBy' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'guide',
      type: 'tas-approver-guide',
      options: { async: false, inverse: null },
    },
  ],
});

export default TasApproverGuideSuggestionSchema;
